<script setup lang="ts">
import projectsService from '@/services/ide/projects.service'
import settingService from '@/services/ide/settings/setting.service'
import { useIdeStore } from '@/stores/ide.store'
import { computed } from 'vue'

const props = defineProps({
  title: {
    type: String,
    required: false
  },
  class: {
    type: String,
    required: false
  },
  isProjectModal: {
    type: Boolean,
    required: false,
    default: false
  },
  closeFunction: {
    type: Function,
    required: false
  },
  isHeaderHidden: {
    type: Boolean,
    required: false,
    default: false
  }
})

const ideStore = useIdeStore()

const isDefaultIde = computed(() => {
  return ideStore.isDefaultIde
})

/**
 * Sets setting store value to close popup
 */
function handleCloseIdeModal() {
  settingService.closePopup()
  if (window.innerWidth < 640) {
    useIdeStore().setSideBarCollapsed(true)
  }

  if (ideStore.isSelectedProject) {
    ideStore.setSelectedProject(null)
  }

  if (props.closeFunction) {
    props.closeFunction()
  }
}
</script>

<template>
  <div
    class="hs-overlay fixed left-0 top-0 z-[60] h-screen w-full overflow-x-auto overflow-y-auto [--overlay-backdrop:false]"
    :class="{
      'bg-gray-900 bg-opacity-70 backdrop-blur-sm dark:bg-opacity-40': isDefaultIde,
      'bg-gray-900 bg-opacity-40 backdrop-blur-sm dark:bg-opacity-40': !isDefaultIde
    }"
  >
    <div
      class="m-0 flex min-h-screen w-full justify-center p-8 transition-all ease-out hs-overlay-open:duration-500"
    >
      <div
        :class="`fixed top-0 mx-auto  h-auto w-full sm:relative sm:top-[unset] sm:w-auto sm:min-w-[65vw] md:min-w-[50vw] lg:min-w-[40vw] ${props.class} `"
      >
        <div
          class="background-quaternary flex h-screen w-screen flex-col overflow-hidden border-border-primary sm:h-auto sm:w-auto sm:rounded-lg sm:border dark:border-border-primary-dark"
        >
          <!-- START Header -->
          <div
            class="surface-primary-header flex items-center justify-between border-b border-border-primary px-4 py-2 dark:border-border-primary-dark"
            :class="props.isHeaderHidden && 'hidden'"
          >
            <h1 class="text-md inline-block font-medium">
              {{ props.title }}
            </h1>
            <div class="relative flex h-fit max-w-60 items-center gap-6">
              <!-- close button -->

              <div
                v-if="props.isProjectModal"
                class="hidden cursor-pointer items-center gap-2 text-[#5F7394] sm:flex"
                @click="projectsService.toggledModal"
              >
                <FontAwesomeIcon icon="fa-folder-open" class="h-4 w-4" />
                <span class="text-sm font-medium underline">Create a new project </span>
              </div>
              <button
                type="button"
                class="hs-collapse-toggle transition-all"
                @click="handleCloseIdeModal"
              >
                <span class="sr-only">Close</span>
                <FontAwesomeIcon icon="fa-xmark" class="hs-collapse-open:block" />
              </button>
            </div>
          </div>
          <!-- END Header -->

          <!-- Content -->
          <div :class="['h-full w-full px-3 py-3 sm:px-5']">
            <!-- main content -->
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
